import React from 'react';
import styled from 'styled-components/macro';
import { black, brand, grey10, white } from 'variables/colors';
import { fontWeightBold } from 'variables/font';
import { borderRadius } from 'variables/general';

const getBackgroundColor = (color) => {
  switch (color) {
    case 'primary':
      return brand;
    case 'teal':
      return '#63C8C4';
    default:
      return grey10;
  }
};

const Component = styled.div`
  padding: 0.75em;
  color: ${({ color }) => (color ? white : black)};
  font-weight: ${fontWeightBold};
  font-size: ${({ size }) => (size === 'small' ? '0.625em' : '.75em')};
  background-color: ${({ color }) => getBackgroundColor(color)};
  border-radius: ${borderRadius};
`;

const Tag = ({ label, color, className, size }) => (
  <Component className={className} color={color} size={size}>
    {label}
  </Component>
);

export default Tag;
